<template>
  <div>
    <div class="public-goback">
      <img alt :src="g_imgSrc.rightArrow" class="public-goback-img" @click="goback" />
      <div class="public-goback-return" @click="goback">返回</div>
    </div>
    <div>
      <a :href="downloadSrc" target="_blank" ref="downloadButton"></a>
      <el-tabs v-model="activeTabName" v-loading="loading">
        <el-tab-pane label="人员统计" name="first">
          <div class="head">
            <div class="exam-name">{{ paperName }}</div>
            <el-button type="primary" @click="exportUrl(1)">导出</el-button>
          </div>
          <el-table :data="statisticListUser">
            <el-table-column prop="user_name" label="考生姓名" width="180"></el-table-column>
            <el-table-column prop="user_code" label="员工号" width="180"></el-table-column>
            <el-table-column prop="department_name" label="部门"></el-table-column>
            <el-table-column prop="pass_time" label="通过时间" width="200">
              <template slot-scope="scope">
                {{ scope.row | handleTime }}
              </template>
            </el-table-column>
            <el-table-column prop="exam_score" label="成绩" width="180">
              <template slot-scope="scope">
                {{ scope.row | handleScore }}
              </template>
            </el-table-column>
            <el-table-column prop="paper_taken_status" label="状态" width="180">
              <template slot-scope="scope">
                {{ getPaperStatusStr(scope.row.paper_taken_status) }}
              </template>
            </el-table-column>
          </el-table>
          <div>
            <el-pagination
              style="float: right"
              @size-change="changeSizeUser"
              @current-change="changeIndexUser"
              :current-page="paginationUser.pageIndex"
              :page-sizes="[5, 10, 20, 50]"
              :page-size="paginationUser.pageSize"
              layout="total, sizes, prev, pager, next"
              :total="paginationUser.pageTotal"
            ></el-pagination>
          </div>
        </el-tab-pane>
        <el-tab-pane label="题目统计" name="second" v-loading="loading">
          <div class="head">
            <div class="exam-name">{{ paperName }}</div>
            <el-button type="primary" @click="exportUrl(2)">导出</el-button>
          </div>
          <el-table :data="statisticListQuestion" class="table">
            <el-table-column prop="question_name" label="题目名称" width="180"></el-table-column>
            <el-table-column prop="question_type" label="题目类型" width="180">
              <template slot-scope="scope">
                {{ scope.row.question_type | handleQuestionType }}
              </template>
            </el-table-column>
            <el-table-column prop="bank_name" label="所属题库" width="180"></el-table-column>
            <el-table-column
              prop="answered_total_num"
              label="答题次数"
              width="180"
            ></el-table-column>
            <el-table-column
              prop="answered_correct_num"
              label="答对次数"
              width="180"
            ></el-table-column>
            <el-table-column prop="correctRate" label="正确率" width="180">
              <template slot-scope="scope">{{ scope.row | handleCorrectRate }}</template>
            </el-table-column>
          </el-table>
          <div>
            <el-pagination
              style="float: right"
              @size-change="changeSizeQuestion"
              @current-change="changeIndexQuestion"
              :current-page="paginationQuestion.pageIndex"
              :page-sizes="[5, 10, 20, 50]"
              :page-size="paginationQuestion.pageSize"
              layout="total, sizes, prev, pager, next"
              :total="paginationQuestion.pageTotal"
            ></el-pagination>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import { GetExaminationStatistic, ExportExaminationStatistic } from '@/api/exam';
import { query } from '@/libs/utils/util';
export default {
  filters: {
    handleTime(row) {
      if (row.paper_taken_status === 3) {
        // 未考试的情况
        return '-';
      }
      const time = row.pass_time;
      if (time) {
        const date = new Date(time * 1000 + 8 * 3600 * 1000);
        return date.toJSON().substr(0, 19).replace('T', ' ').replace(/-/g, '.');
      }
      return '';
    },
    handleScore(row) {
      if (row.paper_taken_status === 3) {
        // 未考试的情况
        return '-';
      }
      const score = row.exam_score;
      if (score === -1) {
        return '未通过';
      }
      return score;
    },
    handleCorrectRate(row) {
      if (isNaN(row.answered_correct_num / row.answered_total_num)) {
        return '-';
      }
      return `${((row.answered_correct_num / row.answered_total_num) * 100).toFixed(2)}%`;
    },
    handleQuestionType(num) {
      switch (num) {
        case '1':
          return '单选';
        case '2':
          return '多选';
        default:
          return '类型错误';
      }
    },
  },
  data() {
    return {
      activeTabName: 'first', // tab切换
      paperId: 0, // 试卷id
      paperName: '', // 试卷名称
      loading: false,
      // 人员统计的分页信息
      paginationUser: {
        pageIndex: 1,
        pageSize: 10,
        pageTotal: 1,
      },
      // 题目统计的分页信息
      paginationQuestion: {
        pageIndex: 1,
        pageSize: 10,
        pageTotal: 1,
      },
      statisticListUser: [], // 人员统计数据数组
      statisticListQuestion: [], // 题目统计数据数组
      downloadSrc: '', // 数据导出下载链接
    };
  },
  created() {
    this.paperName = query('paper_name');

    const paperId = query('paper_id');
    if (paperId.length === 0) {
      // 判断空字符串
      this.$message.error('考卷paper_id为空！');
      this.loading = true;
    } else if (isNaN(Number(paperId))) {
      // 非数字
      this.$message.error('考卷paper_id异常！');
      this.loading = true;
    } else {
      // 存储
      this.paperId = Number(paperId);
    }
    this.getUserStatisticsList();
    this.getQuestionStatisticsList();
  },
  mounted() {
    // 设置面包屑
    this.g_breadcrumb([
      { menu_name: '考试管理', menu_path: '' },
      { menu_name: '试卷管理', menu_path: 'examPaperManagement' },
      { menu_name: '数据统计' },
    ]);
  },
  methods: {
    goback() {
      this.g_tourl('/saas/examPaperManagement.html');
    },
    // 查询人员数据列表
    getUserStatisticsList() {
      GetExaminationStatistic({
        paper_id: this.paperId,
        static_type: 1,
        page_index: this.paginationUser.pageIndex,
        page_size: this.paginationUser.pageSize,
      }).then((res) => {
        this.statisticListUser = res.user_statistic;
        this.paginationUser.pageTotal = res.user_total;
      });
    },
    // 查询问题数据列表
    getQuestionStatisticsList() {
      GetExaminationStatistic({
        paper_id: this.paperId,
        static_type: 2,
        page_index: this.paginationQuestion.pageIndex,
        page_size: this.paginationQuestion.pageSize,
      }).then((res) => {
        this.statisticListQuestion = res.question_statistic;
        this.paginationQuestion.pageTotal = res.question_total;
      });
    },
    exportUrl(type) {
      ExportExaminationStatistic({
        paper_id: this.paperId,
        file_type: type,
      })
        .then((res) => {
          console.log(res);
          this.downloadSrc = res.file_url;
          this.$nextTick(() => {
            this.$refs.downloadButton.click();
          });
        })
        .catch((e) => {
          this.$message.error(e);
        });
    },
    changeIndexUser(index) {
      this.paginationUser.pageIndex = index;
      this.getUserStatisticsList();
    },
    changeSizeUser(size) {
      this.paginationUser.pageSize = size;
      this.getUserStatisticsList();
    },
    changeIndexQuestion(index) {
      this.paginationQuestion.pageIndex = index;
      this.getQuestionStatisticsList();
    },
    changeSizeQuestion(size) {
      this.paginationQuestion.pageSize = size;
      this.getQuestionStatisticsList();
    },
    getPaperStatusStr(status) {
      switch (status) {
        case 1:
          return '已通过';
        case 2:
          return '未通过';
        case 3:
          return '未考试';
      }
    },
    timeToString(time) {
      if (time) {
        const date = new Date(time * 1000 + 8 * 3600 * 1000);
        return date.toJSON().substr(0, 19).replace('T', ' ');
      }
      return '';
    },
  },
};
</script>

<style scoped lang="scss">
.public-goback {
  position: relative;
  height: 40px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  font-family: PingFangSC-Medium;
  font-size: 16px;
  color: #303133;
  .public-goback-img {
    position: absolute;
    top: 0;
    left: 0;
    width: 24px;
    height: 24px;
    transform: rotateY(180deg);
  }
  .public-goback-return {
    position: absolute;
    top: 4px;
    width: 44px;
    height: 22px;
    left: 28px;
    font-family: PingFangSC-Regular;
    font-size: 16px;
    color: #606266;
    letter-spacing: 0;
    cursor: pointer;
  }
  .public-goback-return:hover {
    color: rgb(47, 150, 255);
  }
}
.head {
  display: flex;
  justify-content: space-between;
  .exam-name {
    font-size: 20px;
    font-weight: 1000;
    line-height: 40px;
  }
}
.table {
  width: 100%;
}
</style>
